<template>
  <section class="dorm-module dorm-board-page">
    <div class="board-top">
      <el-tabs v-model="activeTab" class="board-tabs">
        <el-tab-pane label="住宿看板" name="board" />
        <el-tab-pane label="数据汇总" name="summary" />
      </el-tabs>

      <div v-show="activeTab === 'board'" class="board-search-bar">
        <div class="search-dimension-select">
          <el-select
            v-model="globalSearchType"
            size="small"
            :popper-append-to-body="true"
            popper-class="board-search-dropdown-popper"
            @change="handleGlobalSearch(globalSearchQuery)"
          >
            <el-option label="按房间号" value="room" />
            <el-option label="按学生姓名" value="studentName" />
            <el-option label="按学生学号" value="studentNo" />
            <el-option label="按学生卡号" value="studentCard" />
            <el-option label="综合查询" value="all" />
          </el-select>
        </div>
        <div class="search-divider" />
        <div class="search-input-wrap">
          <i class="el-icon-search search-input-icon" />
          <input
            v-model="globalSearchQuery"
            type="text"
            class="search-native-input"
            :placeholder="globalSearchPlaceholder"
            @keyup.enter="handleGlobalSearch(globalSearchQuery)"
            @input="onGlobalSearchInput"
          >
          <i
            v-if="globalSearchQuery"
            class="el-icon-circle-close search-clear-icon"
            title="清空搜索"
            @click="clearGlobalSearch"
          />
        </div>
        <button class="search-submit-btn" type="button" @click="handleGlobalSearch(globalSearchQuery)">
          <i class="el-icon-search" />
          <span>全校查询</span>
        </button>
      </div>
    </div>

    <!-- 住宿看板 -->
    <section v-show="activeTab === 'board'" class="board-layout dp-layout">
      <section class="dp-left left-panel">
        <div class="panel-head">
          <div class="panel-title">
            <i class="el-icon-office-building" />
            宿舍楼层树
          </div>
          <div v-if="stat" class="panel-stat">
            <span>{{ stat.Occupied || 0 }}/{{ stat.Capacity || 0 }}</span>
            <em>入住率 {{ formatRate(stat.OccupancyRate) }}%</em>
          </div>
        </div>

        <el-tree
          ref="tree"
          class="floor-tree"
          :data="treeData"
          node-key="Id"
          highlight-current
          :default-expanded-keys="defaultExpandedKeys"
          :expand-on-click-node="false"
          :filter-node-method="filterTreeNode"
          :props="{ label: 'Label', children: 'Children' }"
          @node-click="onNodeClick"
        >
          <span slot-scope="{ data }" class="tree-node" :class="'is-' + data.Type">
            <span class="node-main">
              <span class="node-label">{{ data.Label }}</span>
              <span
                v-if="data.Type === 'building'"
                class="gender-pill"
                :class="data.Gender === 1 ? 'female' : 'male'"
              >{{ data.Gender === 1 ? '女' : '男' }}</span>
            </span>
            <span class="occ-badge">{{ data.Occupied || 0 }}/{{ data.Capacity || 0 }}</span>
          </span>
        </el-tree>
      </section>

      <section class="dp-right dorm-card right-panel">
        <div class="room-toolbar">
          <div class="selection-meta">
            <h3 v-if="isSearching">
              全校搜索结果：「{{ globalSearchQuery }}」
              <small>(共 {{ filteredRooms.length }} 个匹配房间)</small>
            </h3>
            <h3 v-else>{{ selectionTitle }}</h3>
            <el-tag
              v-if="!isSearching && currentBuildingId"
              size="mini"
              :type="currentBuildingGender === 1 ? 'danger' : ''"
              effect="plain"
            >{{ currentBuildingGender === 1 ? '女生宿舍' : '男生宿舍' }}</el-tag>
          </div>

          <div class="toolbar-filter-bar">
            <el-form :inline="true" class="toolbar-filter-form">
              <div class="toolbar-filter-fields">
              <el-form-item class="chip-group-item">
                <div class="chip-group">
                  <button
                    v-for="item in quickFilters"
                    :key="item.key"
                    type="button"
                    class="chip"
                    :class="{ active: quickFilter === item.key }"
                    @click="setQuickFilter(item.key)"
                  >{{ item.label }}</button>
                </div>
              </el-form-item>
              <el-form-item label="房间类型">
                <el-select
                  v-model="roomType"
                  clearable
                  placeholder="房间类型"
                  class="toolbar-field-w-sm"
                  @change="() => loadRooms()"
                >
                  <el-option label="学生房" :value="0" />
                  <el-option label="宿管房" :value="1" />
                  <el-option label="非居住" :value="2" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="!isSearching" label="房间号">
                <el-input
                  v-model="query"
                  clearable
                  placeholder="房间号"
                  class="toolbar-field-w-md"
                  @keyup.enter.native="() => loadRooms()"
                  @clear="() => loadRooms()"
                />
              </el-form-item>
              <el-form-item v-if="!isSearching">
                <el-button size="small" type="primary" icon="el-icon-search" @click="() => loadRooms()">查询</el-button>
              </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

        <div v-loading="loading" class="room-grid">
          <el-popover
            v-for="room in filteredRooms"
            :key="room.Id"
            placement="right-start"
            trigger="hover"
            :open-delay="180"
            :disabled="room.RoomType === 2"
            popper-class="dorm-room-roster-pop"
            width="340"
          >
            <div class="roster-pop">
              <div class="roster-head">
                <strong>{{ room.RoomCode || room.RoomName }}室人员名册</strong>
                <span>{{ room.Occupied || 0 }}/{{ room.Capacity || 0 }}人</span>
              </div>
              <ul v-if="room.Beds && room.Beds.length" class="roster-list">
                <li v-for="bed in room.Beds" :key="bed.Id">
                  <em>{{ bed.Number }}号床</em>
                  <template v-if="isBedOccupied(bed)">
                    <span class="mini-avatar">
                      <img v-if="bed.HeadPhotoImage" v-oss-src="bed.HeadPhotoImage" alt="" />
                      <span v-else>{{ occupantInitial(bed) }}</span>
                    </span>
                    <span class="who">{{ bed.OccupantName || '已入住' }}</span>
                    <span v-if="bed.ClassName" class="klass" :title="bed.ClassName">{{ bed.ClassName }}</span>
                    <span v-if="bed.OccupantNo" class="no">({{ bed.OccupantNo }})</span>
                    <span
                      v-if="bed.UserId > 0"
                      class="presence"
                      :class="presenceClass(bed.PresenceStatus)"
                    >{{ presenceShort(bed.PresenceStatus) }}</span>
                  </template>
                  <span v-else class="empty">空闲</span>
                </li>
              </ul>
              <div v-else class="roster-empty">暂无床位数据</div>
              <div class="roster-tip">点击卡片进入床位办理详情</div>
            </div>
            <div
              slot="reference"
              class="room-card"
              :class="[roomCardClass(room), { 'is-search-matched': isRoomSearchMatched(room), 'has-inspect': !!inspectOverlayMap[room.Id], 'has-deduct': inspectHasDeduct(room) }]"
              @click="openBeds(room)"
            >
              <div v-if="isSearching && (room.BuildingName || room.FloorName)" class="room-loc">
                {{ room.BuildingName }}{{ room.FloorName ? ' · ' + room.FloorName : '' }}
              </div>
              <div class="room-head">
                <span class="room-code">{{ room.RoomCode || room.RoomName }}</span>
                <span class="room-type" :class="'type-' + room.RoomType">{{ roomTypeText(room.RoomType) }}</span>
              </div>
              <div
                v-if="room.RoomType === 0 && inspectOverlayMap[room.Id]"
                class="inspect-badges"
                title="查看当日宿舍检查"
                @click.stop="openInspectSummary(room)"
              >
                <span class="inspect-badge inspected">已检</span>
                <span v-if="inspectHasDeduct(room)" class="inspect-badge deduct">有扣分</span>
              </div>

              <template v-if="room.RoomType !== 2">
                <div class="bed-dots">
                  <span
                    v-for="bed in room.Beds"
                    :key="bed.Id"
                    class="dot"
                    :class="bedDotClass(bed)"
                  />
                  <span v-if="!(room.Beds && room.Beds.length)" class="no-bed">暂无床位</span>
                </div>
                <div class="room-foot">
                  <div class="bar-wrap">
                    <div class="bar" :style="{ width: roomPercent(room) + '%' }" />
                  </div>
                  <span class="cap">{{ room.Occupied || 0 }}/{{ room.Capacity || 0 }}</span>
                </div>
              </template>
              <div v-else class="non-live">非居住用途</div>
            </div>
          </el-popover>

          <div v-if="!loading && !filteredRooms.length" class="empty-state">
            <i class="el-icon-house" />
            <p>{{ isSearching ? '全校未找到匹配的宿舍房间' : '暂无符合条件的房间' }}</p>
          </div>
        </div>
      </section>
    </section>

    <!-- 数据汇总 -->
    <div v-show="activeTab === 'summary'" class="summary-layout dorm-card">
      <div class="kpi-row">
        <div
          v-for="item in kpiCards"
          :key="item.label"
          class="kpi-card dorm-card"
          :class="{ 'is-clickable': item.clickable }"
          :title="item.clickable ? '点击查看明细' : ''"
          @click="item.clickable && openSummaryDetail(item.type, item.detailTitle)"
        >
          <div class="kpi-icon" :style="{ background: item.bg, color: item.color }">
            <i :class="item.icon" />
          </div>
          <div class="kpi-body">
            <div class="kpi-value">{{ item.value }}<small>{{ item.unit }}</small></div>
            <div class="kpi-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 当日宿舍检查覆盖（无数据时与现网一致，数字为 0） -->
      <div class="inspect-summary-row dorm-card">
        <div class="summary-head">
          <h3>当日宿舍检查</h3>
          <span>{{ boardInspectDate }}</span>
        </div>
        <div class="inspect-kpi-grid">
          <div class="inspect-kpi">
            <em>应检学生房</em>
            <strong>{{ boardInspectStats.studentRoomCount }}</strong>
          </div>
          <div class="inspect-kpi">
            <em>已检</em>
            <strong>{{ boardInspectStats.inspectedCount }}</strong>
          </div>
          <div class="inspect-kpi">
            <em>覆盖率</em>
            <strong>{{ boardInspectStats.coverageRate }}%</strong>
          </div>
          <div class="inspect-kpi warn">
            <em>有扣分房间</em>
            <strong>{{ boardInspectStats.deductCount }}</strong>
          </div>
        </div>
      </div>

      <div class="gender-row">
        <div
          class="gender-card dorm-card male is-clickable"
          title="点击查看男生宿舍入住明细"
          @click="openSummaryDetail('boyOccupied', '男生宿舍 - 已入住学生明细')"
        >
          <div class="gender-head">
            <span>男生宿舍</span>
            <strong>{{ maleRate }}%</strong>
          </div>
          <div class="gender-bar"><i :style="{ width: maleRate + '%' }" /></div>
          <div class="gender-meta">
            <span>床位 {{ (stat && stat.MaleCapacity) || 0 }}</span>
            <span>已住 {{ (stat && stat.MaleOccupied) || 0 }}</span>
            <span>空闲 {{ maleEmpty }}</span>
          </div>
        </div>
        <div
          class="gender-card dorm-card female is-clickable"
          title="点击查看女生宿舍入住明细"
          @click="openSummaryDetail('girlOccupied', '女生宿舍 - 已入住学生明细')"
        >
          <div class="gender-head">
            <span>女生宿舍</span>
            <strong>{{ femaleRate }}%</strong>
          </div>
          <div class="gender-bar"><i :style="{ width: femaleRate + '%' }" /></div>
          <div class="gender-meta">
            <span>床位 {{ (stat && stat.FemaleCapacity) || 0 }}</span>
            <span>已住 {{ (stat && stat.FemaleOccupied) || 0 }}</span>
            <span>空闲 {{ femaleEmpty }}</span>
          </div>
        </div>
      </div>

      <div class="building-summary dorm-card">
        <div class="summary-head">
          <h3>楼栋入住汇总</h3>
          <span>共 {{ treeData.length }} 栋（点击数字查看明细）</span>
        </div>
        <div class="building-grid">
          <div v-for="b in treeData" :key="b.Id" class="building-card">
            <div
              class="bc-head is-clickable"
              title="点击查看该楼栋入住明细"
              @click="openSummaryDetail('buildingOccupied', b.Label + ' - 已入住学生明细', { buildingId: b.BuildingId || b.Id })"
            >
              <div class="bc-title">
                <strong>{{ b.Label }}</strong>
                <span class="gender-pill" :class="b.Gender === 1 ? 'female' : 'male'">
                  {{ b.Gender === 1 ? '女宿' : '男宿' }}
                </span>
              </div>
              <span class="bc-floors">{{ (b.Children || []).length }} 层</span>
            </div>
            <div class="bc-stats">
              <span
                class="is-clickable"
                @click.stop="openSummaryDetail('totalBeds', b.Label + ' - 全部床位明细', { buildingId: b.BuildingId || b.Id })"
              >床位 {{ b.Capacity || 0 }}</span>
              <span
                class="is-clickable"
                @click.stop="openSummaryDetail('buildingOccupied', b.Label + ' - 已入住学生明细', { buildingId: b.BuildingId || b.Id })"
              >已住 {{ b.Occupied || 0 }}</span>
              <span
                class="is-clickable"
                @click.stop="openSummaryDetail('emptyBeds', b.Label + ' - 空闲床位明细', { buildingId: b.BuildingId || b.Id })"
              >空闲 {{ Math.max(0, (b.Capacity || 0) - (b.Occupied || 0)) }}</span>
              <span class="rate">{{ nodeRate(b) }}%</span>
            </div>
            <div class="bc-floors-list">
              <div
                v-for="f in (b.Children || [])"
                :key="f.Id"
                class="floor-row is-clickable"
                title="点击查看该楼层入住明细"
                @click="openSummaryDetail('floorOccupied', b.Label + ' ' + f.Label + ' - 已入住学生明细', { buildingId: b.BuildingId || b.Id, floorId: f.FloorId || f.Id })"
              >
                <span class="flabel">{{ f.Label }}</span>
                <span class="fnum">{{ f.Occupied || 0 }} / {{ f.Capacity || 0 }}</span>
                <div class="fbar"><i :style="{ width: nodeRate(f) + '%' }" /></div>
              </div>
              <div v-if="!(b.Children && b.Children.length)" class="floor-empty">暂无楼层</div>
            </div>
          </div>
        </div>
        <div v-if="!treeData.length" class="empty-state compact">暂无楼栋数据</div>
      </div>
    </div>

    <el-dialog
      :title="detailDialogTitle"
      :visible.sync="detailDialogVisible"
      width="1080px"
      top="6vh"
      append-to-body
      custom-class="dorm-summary-detail-dialog"
      :close-on-click-modal="false"
    >
      <div class="detail-filter">
          <el-form :inline="true" size="small" @submit.native.prevent>
          <el-form-item label="楼栋">
            <el-select v-model="detailBuildingId" placeholder="全部楼栋" clearable style="width: 150px" @change="onDetailBuildingChange">
              <el-option v-for="b in treeData" :key="b.Id" :label="b.Label" :value="b.BuildingId || b.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="楼层">
            <el-select v-model="detailFloorId" placeholder="全部楼层" clearable style="width: 130px" :disabled="!detailBuildingId" @change="handleDetailFilterChange">
              <el-option v-for="f in detailFloorOptions" :key="f.Id" :label="f.Label" :value="f.FloorId || f.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="房间类型">
            <el-select v-model="detailRoomType" placeholder="全部房间" clearable style="width: 120px" @change="handleDetailFilterChange">
              <el-option label="学生宿舍" :value="0" />
              <el-option label="宿管房" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="detailDataType === 'student'" label="性别">
            <el-radio-group v-model="detailGender" size="small" @change="handleDetailFilterChange">
              <el-radio-button label="all">全部</el-radio-button>
              <el-radio-button label="boy">男</el-radio-button>
              <el-radio-button label="girl">女</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="搜索">
            <el-input
              v-model="detailQuery"
              clearable
              placeholder="姓名/学号/房号/班级"
              prefix-icon="el-icon-search"
              style="width: 180px"
              @keyup.enter.native="handleDetailFilterChange"
              @clear="handleDetailFilterChange"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetDetailFilters">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="detail-count">筛选结果：共 <strong>{{ detailTotal }}</strong> 条</div>
      <el-table v-if="detailDataType === 'student'" v-loading="detailLoading" :data="detailList" border size="small" max-height="420">
        <el-table-column prop="OccupantName" label="姓名" align="center" width="120">
          <template slot-scope="scope">
            <strong>{{ scope.row.OccupantName || '—' }}</strong>
            <el-tag v-if="scope.row.OccupantType === '教师'" size="mini" type="warning" style="margin-left: 4px">教师</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="OccupantNo" label="学号/工号" align="center" width="130">
          <template slot-scope="scope">{{ scope.row.OccupantNo || '—' }}</template>
        </el-table-column>
        <el-table-column prop="ClassName" label="班级/部门" align="center" min-width="140" show-overflow-tooltip />
        <el-table-column prop="GenderText" label="性别" align="center" width="70">
          <template slot-scope="scope">{{ scope.row.GenderText || '—' }}</template>
        </el-table-column>
        <el-table-column prop="BuildingName" label="宿舍楼栋" align="center" width="140" />
        <el-table-column prop="FloorName" label="楼层" align="center" width="100" />
        <el-table-column prop="RoomCode" label="房间号" align="center" width="100">
          <template slot-scope="scope">
            <span class="detail-room">{{ scope.row.RoomCode }}室</span>
          </template>
        </el-table-column>
        <el-table-column prop="BedNumber" label="床位" align="center" width="90">
          <template slot-scope="scope">{{ scope.row.BedNumber }}号床</template>
        </el-table-column>
      </el-table>
      <el-table v-else v-loading="detailLoading" :data="detailList" border size="small" max-height="420">
        <el-table-column prop="BuildingName" label="宿舍楼栋" align="center" min-width="140" />
        <el-table-column prop="FloorName" label="楼层" align="center" width="110" />
        <el-table-column prop="RoomCode" label="房间号" align="center" width="120">
          <template slot-scope="scope">
            <span class="detail-room">{{ scope.row.RoomCode }}室</span>
          </template>
        </el-table-column>
        <el-table-column label="床位 / 状态" align="center" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.BedNumber">{{ scope.row.BedNumber }}号床</span>
            <span v-else>整间房间（容量 {{ scope.row.Capacity }} 人）</span>
          </template>
        </el-table-column>
        <el-table-column label="房间类型" align="center" width="120">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.RoomType === 1 ? 'warning' : 'info'">
              {{ scope.row.RoomType === 1 ? '宿管房' : '学生宿舍' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="detail-pager">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="detailPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="detailPageSize"
          :total="detailTotal"
          @current-change="onDetailPageChange"
          @size-change="onDetailPageSizeChange"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="small" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 当日宿舍检查摘要。创建于 2026-09-14 -->
    <el-dialog title="当日宿舍检查" :visible.sync="inspectDialogVisible" width="480px" append-to-body
      :close-on-click-modal="false">
      <div v-if="inspectSummary" class="inspect-summary-body">
        <p><span>房间</span><strong>{{ inspectSummary.BuildingName }} {{ inspectSummary.RoomCode }}</strong></p>
        <p><span>检查人</span><strong>{{ inspectSummary.InspectorName || '-' }}</strong></p>
        <p><span>摘要</span><strong>{{ inspectSummary.SelectedItemsSummary || inspectSummary.Summary || '—' }}</strong></p>
        <p>
          <span>宿舍分</span>
          <strong :class="Number(inspectSummary.TotalScore) < 0 ? 'deduct-text' : ''">
            {{ inspectSummary.TotalScore != null ? inspectSummary.TotalScore : '-' }}
          </strong>
        </p>
        <p><span>班级</span><strong>{{ formatInspectClasses(inspectSummary) }}</strong></p>
        <p>
          <span>同步值周</span>
          <el-tag size="mini" :type="inspectSummary.Synced || inspectSummary.HasDutyLink ? 'success' : 'info'">
            {{ inspectSummary.Synced || inspectSummary.HasDutyLink ? '已同步' : '未同步' }}
          </el-tag>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="inspectDialogVisible = false">关闭</el-button>
        <el-button @click="openInspectRecordsDialog">查看记录</el-button>
        <el-button type="primary" @click="openBedsFromInspect">查看床位</el-button>
      </div>
    </el-dialog>

    <!-- 当日该房检查记录列表（弹窗，不跳转）。创建于 2026-09-14 -->
    <el-dialog
      :title="inspectRecordsTitle"
      :visible.sync="inspectRecordsVisible"
      width="860px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-table
        :data="inspectRecords"
        v-loading="inspectRecordsLoading"
        size="small"
        border
        max-height="420"
        empty-text="当日暂无检查记录"
      >
        <el-table-column prop="InspectorName" label="检查人" width="100" show-overflow-tooltip />
        <el-table-column prop="SelectedItemsSummary" label="摘要" min-width="180" show-overflow-tooltip />
        <el-table-column prop="TotalScore" label="明细净分" width="90" align="center">
          <template slot-scope="scope">
            <span :class="Number(scope.row.TotalScore) < 0 ? 'deduct-text' : ''">
              {{ scope.row.TotalScore != null ? scope.row.TotalScore : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="班级" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatInspectClasses(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="同步值周" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.Synced || scope.row.HasDutyLink ? 'success' : 'info'">
              {{ scope.row.Synced || scope.row.HasDutyLink ? '已同步' : '未同步' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="提交时间" width="160" align="center" />
        <el-table-column label="操作" width="90" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openInspectRecordDetail(scope.row)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="inspectRecordsVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 单条检查明细弹窗 -->
    <el-dialog
      title="宿舍检查明细"
      :visible.sync="inspectDetailVisible"
      width="720px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div v-if="inspectDetailLoading" style="text-align:center;padding:20px;">加载中...</div>
      <div v-else-if="inspectDetail">
        <div class="inspect-summary-body">
          <p>
            <span>房间</span>
            <strong>{{ inspectDetail.BuildingName }} {{ inspectDetail.RoomCode }}</strong>
          </p>
          <p><span>检查人</span><strong>{{ inspectDetail.InspectorName || '-' }}</strong></p>
          <p><span>日期</span><strong>{{ formatInspectDate(inspectDetail.InspectDate) }}</strong></p>
          <p>
            <span>明细净分</span>
            <strong :class="Number(inspectDetail.TotalScore) < 0 ? 'deduct-text' : ''">
              {{ inspectDetail.TotalScore != null ? inspectDetail.TotalScore : '-' }}
            </strong>
          </p>
          <p><span>班级</span><strong>{{ formatInspectClasses(inspectDetail) }}</strong></p>
          <p><span>摘要</span><strong>{{ inspectDetail.SelectedItemsSummary || '—' }}</strong></p>
          <p v-if="inspectDetail.Remark"><span>备注</span><strong>{{ inspectDetail.Remark }}</strong></p>
        </div>
        <el-table :data="inspectDetail.Items || []" border size="small" style="margin-top:10px;">
          <el-table-column prop="ItemName" label="检查项" min-width="140" />
          <el-table-column prop="Quantity" label="数量" width="70" align="center" />
          <el-table-column prop="UnitScore" label="单项分" width="90" align="center">
            <template slot-scope="scope">
              <span :class="Number(scope.row.UnitScore) < 0 ? 'deduct-text' : ''">{{ scope.row.UnitScore }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Score" label="得分" width="90" align="center">
            <template slot-scope="scope">
              <span :class="Number(scope.row.Score) < 0 ? 'deduct-text' : ''">{{ scope.row.Score }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="inspectDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <dorm-bed-manager-dialog
      :visible.sync="bedVisible"
      :building-id="currentRoomBuildingId"
      :building-gender="currentBuildingGender"
      :room-id="currentRoomId"
      :room-snapshot="currentRoomSnapshot"
      :search-query="isSearching ? globalSearchQuery : ''"
      :school-department-id="schoolDepartmentId"
      @changed="refresh"
    />
  </section>
</template>

<script>
import { getBuildingsTree, getBuildingsStatistic, getRoomsWithBeds, getOccupancyDetails, getDormInspectBoardOverlay, getDormInspectRecords, getDormInspectRecordDetail } from '../../api/modules/dormitory'
import DormBedManagerDialog from './components/DormBedManagerDialog.vue'
import '../../styles/dorm-module.css'

export default {
  name: 'DormBoard',
  components: { DormBedManagerDialog },
  data() {
    return {
      activeTab: 'board',
      treeData: [],
      defaultExpandedKeys: [],
      stat: null,
      rooms: [],
      roomsRequestId: 0,
      refreshRequestId: 0,
      loading: false,
      currentBuildingId: 0,
      currentFloorId: 0,
      currentLabel: '',
      roomType: null,
      query: '',
      quickFilter: 'all',
      bedVisible: false,
      currentRoomId: 0,
      currentRoomSnapshot: null,
      currentRoomBuildingId: 0,
      lastSelectedNode: null,
      globalSearchType: 'studentName',
      globalSearchQuery: '',
      isSearching: false,
      matchedBuildingIds: [],
      matchedFloorIds: [],
      searchDebounceTimer: null,
      detailDialogVisible: false,
      detailDialogTitle: '',
      detailType: 'occupied',
      detailDataType: 'student',
      detailList: [],
      detailTotal: 0,
      detailLoading: false,
      detailPage: 1,
      detailPageSize: 10,
      detailBuildingId: null,
      detailFloorId: null,
      detailRoomType: null,
      detailQuery: '',
      detailGender: 'all',
      /** 房间检查覆盖：RoomId -> 摘要 */
      inspectOverlayMap: {},
      inspectDialogVisible: false,
      inspectSummary: null,
      inspectPendingRoom: null,
      inspectRecordsVisible: false,
      inspectRecordsLoading: false,
      inspectRecords: [],
      inspectRecordsTitle: '当日检查记录',
      inspectDetailVisible: false,
      inspectDetailLoading: false,
      inspectDetail: null,
      boardInspectDate: '',
      boardInspectStats: {
        studentRoomCount: 0,
        inspectedCount: 0,
        coverageRate: 0,
        deductCount: 0,
      },
      quickFilters: [
        { key: 'all', label: '全部' },
        { key: 'hasEmpty', label: '有空床' },
        { key: 'full', label: '已满' },
        { key: 'empty', label: '空房' },
        { key: 'manager', label: '宿管房' },
        { key: 'nonLive', label: '非居住' }
      ]
    }
  },
  computed: {
    schoolDepartmentId() {
      const id = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId') || ''
      return id || 0
    },
    currentBuildingGender() {
      const targetId = (this.bedVisible && this.currentRoomBuildingId) || this.currentBuildingId
      const find = (nodes) => {
        for (const n of nodes || []) {
          const bid = n.BuildingId || n.Id
          if (n.Type === 'building' && String(bid) === String(targetId)) {
            return n.Gender == null ? 0 : n.Gender
          }
          const hit = find(n.Children || n.children)
          if (hit != null) return hit
        }
        return null
      }
      const g = find(this.treeData)
      return g == null ? 0 : g
    },
    selectionTitle() {
      if (this.currentLabel) return this.currentLabel
      if (this.currentBuildingId) return '已选楼栋'
      return '请选择楼栋或楼层'
    },
    globalSearchPlaceholder() {
      if (this.globalSearchType === 'room') return '请输入宿舍房号（如 101、201）...'
      if (this.globalSearchType === 'studentName') return '请输入学生/老师姓名...'
      if (this.globalSearchType === 'studentNo') return '请输入学生学号...'
      if (this.globalSearchType === 'studentCard') return '请输入学生卡号...'
      return '全校搜索房号、学生姓名、学号、卡号...'
    },
    detailFloorOptions() {
      if (!this.detailBuildingId) return []
      const building = (this.treeData || []).find(b => String(b.BuildingId || b.Id) === String(this.detailBuildingId))
      return (building && building.Children) || []
    },
    filteredRooms() {
      const list = this.rooms || []
      if (this.quickFilter === 'all') return list
      return list.filter((room) => {
        const cap = room.Capacity || 0
        const occ = room.Occupied || 0
        if (this.quickFilter === 'hasEmpty') return room.RoomType !== 2 && cap > 0 && occ < cap
        if (this.quickFilter === 'full') return room.RoomType !== 2 && cap > 0 && occ >= cap
        if (this.quickFilter === 'empty') return room.RoomType !== 2 && cap > 0 && occ === 0
        if (this.quickFilter === 'manager') return room.RoomType === 1
        if (this.quickFilter === 'nonLive') return room.RoomType === 2
        return true
      })
    },
    kpiCards() {
      const s = this.stat || {}
      return [
        { type: 'totalBeds', clickable: true, detailTitle: '全校床位汇总明细', label: '总床位', value: s.Capacity || 0, unit: '张', icon: 'el-icon-s-grid', bg: '#ccfbf1', color: '#0f766e' },
        { type: 'occupied', clickable: true, detailTitle: '已入住学生明细', label: '已入住', value: s.Occupied || 0, unit: '人', icon: 'el-icon-user-solid', bg: '#dbeafe', color: '#1d4ed8' },
        { type: 'emptyBeds', clickable: true, detailTitle: '空闲床位明细', label: '空闲床位', value: s.Empty || 0, unit: '张', icon: 'el-icon-s-opportunity', bg: '#fef3c7', color: '#b45309' },
        { type: 'rate', clickable: false, label: '总入住率', value: this.formatRate(s.OccupancyRate), unit: '%', icon: 'el-icon-data-analysis', bg: '#e0e7ff', color: '#4338ca' },
        { type: 'totallyEmptyRooms', clickable: true, detailTitle: '全空房间明细', label: '全空房间', value: s.EmptyRoomCount || 0, unit: '间', icon: 'el-icon-house', bg: '#fce7f3', color: '#be185d' }
      ]
    },
    maleRate() {
      const s = this.stat || {}
      if (!s.MaleCapacity) return 0
      return Math.round((s.MaleOccupied || 0) * 100 / s.MaleCapacity)
    },
    femaleRate() {
      const s = this.stat || {}
      if (!s.FemaleCapacity) return 0
      return Math.round((s.FemaleOccupied || 0) * 100 / s.FemaleCapacity)
    },
    maleEmpty() {
      const s = this.stat || {}
      return Math.max(0, (s.MaleCapacity || 0) - (s.MaleOccupied || 0))
    },
    femaleEmpty() {
      const s = this.stat || {}
      return Math.max(0, (s.FemaleCapacity || 0) - (s.FemaleOccupied || 0))
    }
  },
  watch: {
    schoolDepartmentId: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue === oldValue && oldValue !== undefined) return
        this.refresh()
      }
    }
  },
  beforeDestroy() {
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer)
  },
  methods: {
    formatRate(v) {
      if (v == null || v === '') return 0
      return Number(v)
    },
    nodeRate(node) {
      const cap = (node && node.Capacity) || 0
      if (!cap) return 0
      return Math.round(((node.Occupied || 0) * 100) / cap)
    },
    roomPercent(room) {
      const cap = room.Capacity || 0
      if (!cap) return 0
      return Math.min(100, Math.round(((room.Occupied || 0) * 100) / cap))
    },
    isBedOccupied(bed) {
      return !!(bed && (bed.UserId > 0 || bed.TeacherId > 0))
    },
    occupantInitial(bed) {
      const name = (bed && bed.OccupantName) || ''
      return name ? name.trim().slice(0, 1).toUpperCase() : '住'
    },
    presenceShort(status) {
      if (status === '已归寝') return '在寝'
      return status || '未打卡'
    },
    presenceClass(status) {
      const s = status || '未打卡'
      if (s === '已归寝' || s === '迟归') return 'is-in'
      if (s === '离寝') return 'is-out'
      if (s === '请假') return 'is-leave'
      if (s === '未归' || s === '未离') return 'is-miss'
      return 'is-unknown'
    },
    bedDotClass(bed) {
      const matched = this.isSearching && this.isBedSearchMatched(bed)
      if (!this.isBedOccupied(bed)) return matched ? 'is-matched' : ''
      if (!(bed.UserId > 0)) return matched ? 'on is-matched' : 'on'
      const s = bed.PresenceStatus || '未打卡'
      if (s === '已归寝' || s === '迟归') return matched ? 'on is-in is-matched' : 'on is-in'
      if (s === '离寝') return matched ? 'on is-out is-matched' : 'on is-out'
      if (s === '请假') return matched ? 'on is-leave is-matched' : 'on is-leave'
      return matched ? 'on is-unknown is-matched' : 'on is-unknown'
    },
    roomTypeText(t) {
      if (t === 1) return '宿管房'
      if (t === 2) return '非居住'
      return '学生'
    },
    roomCardClass(room) {
      if (room.RoomType === 2) return 'is-nonlive'
      if (room.RoomType === 1) return 'is-manager'
      const cap = room.Capacity || 0
      const occ = room.Occupied || 0
      if (cap > 0 && occ >= cap) return 'is-full'
      if (cap > 0 && occ === 0) return 'is-empty'
      return ''
    },
    setQuickFilter(key) {
      this.quickFilter = key
      if (key === 'manager') {
        this.roomType = 1
        this.loadRooms()
      } else if (key === 'nonLive') {
        this.roomType = 2
        this.loadRooms()
      } else if (this.roomType === 1 || this.roomType === 2) {
        this.roomType = null
        this.loadRooms()
      }
    },
    async refresh() {
      const schoolId = String(this.schoolDepartmentId || '')
      const refreshRequestId = ++this.refreshRequestId

      // 切换学校时不能沿用旧学校的楼栋、楼层、房间和统计。
      this.roomsRequestId += 1
      this.treeData = []
      this.defaultExpandedKeys = []
      this.stat = null
      this.rooms = []
      this.loading = false
      this.currentBuildingId = 0
      this.currentFloorId = 0
      this.currentLabel = ''
      this.currentRoomId = 0
      this.currentRoomSnapshot = null
      this.currentRoomBuildingId = 0
      this.bedVisible = false
      this.isSearching = false
      this.globalSearchQuery = ''
      this.matchedBuildingIds = []
      this.matchedFloorIds = []
      this.lastSelectedNode = null

      if (!schoolId) {
        this.$message.warning('请先在顶栏选择学校')
        return
      }
      await Promise.all([this.loadTree(schoolId), this.loadStat(schoolId)])
      if (refreshRequestId !== this.refreshRequestId || schoolId !== String(this.schoolDepartmentId || '')) return
      if (this.currentBuildingId) await this.loadRooms(schoolId)
    },
    async loadTree(schoolId = this.schoolDepartmentId) {
      const requestSchoolId = String(schoolId || '')
      const res = await getBuildingsTree({ departmentId: requestSchoolId })
      if (requestSchoolId === String(this.schoolDepartmentId || '') && res.data && res.data.success) {
        this.treeData = res.data.response || []
        if (!this.currentBuildingId && this.treeData.length) {
          const first = this.treeData[0]
          this.defaultExpandedKeys = [first.Id]
          this.currentBuildingId = first.BuildingId || first.Id
          this.currentFloorId = 0
          this.currentLabel = first.Label
          this.$nextTick(() => {
            if (this.$refs.tree) this.$refs.tree.setCurrentKey(first.Id)
          })
        }
      }
    },
    async loadStat(schoolId = this.schoolDepartmentId) {
      const requestSchoolId = String(schoolId || '')
      const res = await getBuildingsStatistic({ departmentId: requestSchoolId })
      if (requestSchoolId === String(this.schoolDepartmentId || '') && res.data && res.data.success) this.stat = res.data.response
      // 汇总区当日检查覆盖（全校；后端可按 school/department 汇总）
      await this.loadSchoolInspectSummary(requestSchoolId)
    },
    /** 数据汇总 Tab 用的当日检查统计（不绑具体楼） */
    async loadSchoolInspectSummary(schoolId) {
      const today = this.formatToday()
      this.boardInspectDate = today
      try {
        const res = await getDormInspectBoardOverlay({
          departmentId: schoolId || undefined,
          date: today,
        })
        if (!(res.data && res.data.success)) return
        const resp = res.data.response || {}
        const studentRoomCount = Number(
          resp.TotalStudentRooms != null ? resp.TotalStudentRooms : resp.StudentRoomCount
        ) || 0
        const inspectedCount = Number(
          resp.InspectedRooms != null ? resp.InspectedRooms : resp.InspectedCount
        ) || 0
        if (studentRoomCount > 0 || inspectedCount > 0 || resp.CoverageRate != null) {
          const deductCount = Number(
            resp.DeductionRooms != null ? resp.DeductionRooms : resp.DeductCount
          ) || 0
          const coverageFromRate = resp.CoverageRate != null
            ? Math.round(Number(resp.CoverageRate) * (Number(resp.CoverageRate) <= 1 ? 100 : 1))
            : 0
          this.boardInspectStats = {
            studentRoomCount,
            inspectedCount,
            coverageRate: studentRoomCount
              ? Math.round((inspectedCount * 100) / studentRoomCount)
              : coverageFromRate,
            deductCount,
          }
        }
      } catch (e) {
        // 后端未就绪时保持 0
      }
    },
    onNodeClick(data) {
      if (this.isSearching) {
        this.globalSearchQuery = ''
        this.exitSearchMode()
      }
      if (data.Type === 'building') {
        this.currentBuildingId = data.BuildingId || data.Id
        this.currentFloorId = 0
        this.currentLabel = data.Label
      } else {
        this.currentBuildingId = data.BuildingId
        this.currentFloorId = data.FloorId || data.Id
        const building = (this.treeData || []).find(b => String(b.BuildingId || b.Id) === String(data.BuildingId))
        this.currentLabel = building ? `${building.Label} · ${data.Label}` : data.Label
      }
      this.lastSelectedNode = data
      this.$nextTick(() => {
        if (this.$refs.tree && data && data.Id) this.$refs.tree.setCurrentKey(data.Id)
      })
      this.loadRooms(this.schoolDepartmentId)
    },
    jumpToBuilding(b) {
      this.exitSearchMode()
      this.activeTab = 'board'
      this.currentBuildingId = b.BuildingId || b.Id
      this.currentFloorId = 0
      this.currentLabel = b.Label
      this.$nextTick(() => {
        if (this.$refs.tree) this.$refs.tree.setCurrentKey(b.Id)
      })
      this.loadRooms(this.schoolDepartmentId)
    },
    /**
     * 加载当前楼栋/楼层房间。最后更新：2026-09-13
     * 注意：模板事件回调可能传入 Event，不能当作 schoolId。
     */
    async loadRooms(schoolId) {
      if (this.isSearching) return
      if (!this.currentBuildingId) {
        this.rooms = []
        return
      }
      // click/change 等会把 Event 传入；仅接受显式字符串/数字学校 ID
      const requestSchoolId = (schoolId != null && typeof schoolId !== 'object')
        ? String(schoolId)
        : String(this.schoolDepartmentId || '')
      const requestId = ++this.roomsRequestId
      // 请求期间不保留上一个楼层/楼栋的房间卡片。
      this.rooms = []
      this.loading = true
      try {
        const res = await getRoomsWithBeds({
          buildingId: this.currentBuildingId,
          floorId: this.currentFloorId || 0,
          roomType: this.roomType === null || this.roomType === '' ? undefined : this.roomType,
          query: (this.query || '').trim(),
          departmentId: requestSchoolId
        })
        // 快速切换楼层时，只允许最后一次请求更新页面。
        if (requestId === this.roomsRequestId && requestSchoolId === String(this.schoolDepartmentId || '') && res.data && res.data.success) {
          this.rooms = res.data.response || []
          this.loadInspectOverlay(this.currentBuildingId)
        }
      } finally {
        if (requestId === this.roomsRequestId) this.loading = false
      }
    },
    /**
     * 按楼拉取当日检查覆盖，前端按 RoomId 映射。创建于 2026-09-14
     */
    async loadInspectOverlay(buildingId) {
      const bid = buildingId || this.currentBuildingId
      if (!bid) {
        this.inspectOverlayMap = {}
        this.resetBoardInspectStats()
        return
      }
      const today = this.formatToday()
      this.boardInspectDate = today
      try {
        const res = await getDormInspectBoardOverlay({
          buildingId: bid,
          date: today,
          departmentId: this.schoolDepartmentId || undefined,
        })
        if (!(res.data && res.data.success)) {
          this.inspectOverlayMap = {}
          this.resetBoardInspectStats()
          return
        }
        const resp = res.data.response || {}
        const list = Array.isArray(resp) ? resp : (resp.Rooms || resp.rooms || resp.Items || [])
        const map = {}
        ;(list || []).forEach((item) => {
          if (!item) return
          // 后端会返回楼内全部学生房；仅 Inspected=true 才算已检
          const inspected = item.Inspected === true || item.inspected === true
          if (!inspected) return
          const roomId = item.RoomId != null ? item.RoomId : item.Id
          if (roomId != null) map[roomId] = item
        })
        this.inspectOverlayMap = map
        const studentRoomCount = Number(
          resp.TotalStudentRooms != null ? resp.TotalStudentRooms : resp.StudentRoomCount
        ) || 0
        const inspectedCount = Number(
          resp.InspectedRooms != null ? resp.InspectedRooms : resp.InspectedCount
        ) || 0
        const deductCount = Number(
          resp.DeductionRooms != null ? resp.DeductionRooms : resp.DeductCount
        ) || 0
        if (studentRoomCount > 0 || inspectedCount > 0 || (list && list.length)) {
          const coverageFromRate = resp.CoverageRate != null
            ? Math.round(Number(resp.CoverageRate) * (Number(resp.CoverageRate) <= 1 ? 100 : 1))
            : 0
          this.boardInspectStats = {
            studentRoomCount,
            inspectedCount,
            coverageRate: studentRoomCount
              ? Math.round((inspectedCount * 100) / studentRoomCount)
              : coverageFromRate,
            deductCount,
          }
        } else {
          this.recomputeBoardInspectStatsFromRooms()
        }
      } catch (e) {
        // 后端未就绪时静默，看板与现网一致
        this.inspectOverlayMap = {}
        this.resetBoardInspectStats()
      }
    },
    formatToday() {
      const d = new Date()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${d.getFullYear()}-${m}-${day}`
    },
    resetBoardInspectStats() {
      this.boardInspectStats = {
        studentRoomCount: 0,
        inspectedCount: 0,
        coverageRate: 0,
        deductCount: 0,
      }
    },
    /** 无汇总字段时，用当前楼房间 + overlay 估算 */
    recomputeBoardInspectStatsFromRooms() {
      const rooms = (this.rooms || []).filter(r => r.RoomType === 0)
      const inspected = rooms.filter(r => this.inspectOverlayMap[r.Id])
      const deduct = inspected.filter(r => this.inspectHasDeduct(r))
      const studentRoomCount = rooms.length
      const inspectedCount = inspected.length
      this.boardInspectStats = {
        studentRoomCount,
        inspectedCount,
        coverageRate: studentRoomCount ? Math.round((inspectedCount * 100) / studentRoomCount) : 0,
        deductCount: deduct.length,
      }
    },
    inspectHasDeduct(room) {
      const ov = room && this.inspectOverlayMap[room.Id]
      if (!ov) return false
      if (ov.HasDeduction === true || ov.hasDeduction === true) return true
      const score = Number(ov.TotalScore != null ? ov.TotalScore : ov.NetScore)
      return !Number.isNaN(score) && score < 0
    },
    formatInspectClasses(summary) {
      if (!summary) return '-'
      if (summary.ClassNames) {
        return Array.isArray(summary.ClassNames) ? summary.ClassNames.join('、') : summary.ClassNames
      }
      if (summary.Classes && summary.Classes.length) {
        return summary.Classes.map(c => c.DepartmentName || c.Name).filter(Boolean).join('、')
      }
      return summary.DepartmentNames || '-'
    },
    /** 点击房间卡片：默认直接打开床位办理。创建于 2026-09-14 */
    openBeds(room) {
      if (room.RoomType === 2) return this.$message.info('非居住房无床位')
      this.currentRoomId = room.Id
      this.currentRoomSnapshot = room
      this.currentRoomBuildingId = room.BuildingId || this.currentBuildingId
      this.bedVisible = true
    },
    /** 点击「已检」角标查看当日检查摘要（不拦截床位入口）。创建于 2026-09-14 */
    openInspectSummary(room) {
      if (!room || room.RoomType !== 0 || !this.inspectOverlayMap[room.Id]) return
      this.inspectPendingRoom = room
      const ov = this.inspectOverlayMap[room.Id] || {}
      this.inspectSummary = {
        ...ov,
        BuildingName: room.BuildingName || ov.BuildingName,
        RoomCode: room.RoomCode || room.RoomName || ov.RoomCode,
        InspectorName: ov.InspectorName || ov.LatestInspectorName,
        SelectedItemsSummary: ov.SelectedItemsSummary || ov.LatestSummary || ov.Summary,
        TotalScore: ov.TotalScore != null ? ov.TotalScore : ov.LatestTotalScore,
        ClassNames: ov.ClassNames || ov.LatestClassNames,
        Synced: ov.Synced || ov.LatestSynced || ov.HasDutyLink,
      }
      this.inspectDialogVisible = true
    },
    openBedsFromInspect() {
      const room = this.inspectPendingRoom
      this.inspectDialogVisible = false
      if (!room) return
      this.openBeds(room)
    },
    /** 查看当日该房检查记录（弹窗，不跳转）。创建于 2026-09-14 */
    openInspectRecordsDialog() {
      const room = this.inspectPendingRoom
      if (!room) return
      const date = this.boardInspectDate || this.formatToday()
      const code = room.RoomCode || room.RoomName || ''
      this.inspectRecordsTitle = `当日检查记录${code ? ' · ' + code : ''}`
      this.inspectRecordsVisible = true
      this.loadInspectRecordsForRoom(room, date)
    },
    loadInspectRecordsForRoom(room, date) {
      const schoolId = this.schoolDepartmentId
      if (!schoolId || !room || !room.Id) {
        this.inspectRecords = []
        return
      }
      this.inspectRecordsLoading = true
      getDormInspectRecords({
        schoolId,
        roomId: room.Id,
        buildingId: room.BuildingId || this.currentBuildingId || undefined,
        startDate: date,
        endDate: date,
        page: 1,
        intPageSize: 50,
      }).then(res => {
        const resp = (res.data && res.data.response) || {}
        this.inspectRecords = resp.data || []
      }).catch(() => {
        this.inspectRecords = []
      }).finally(() => {
        this.inspectRecordsLoading = false
      })
    },
    openInspectRecordDetail(row) {
      const id = row && (row.Id || row.RecordId)
      if (!id) return
      this.inspectDetailVisible = true
      this.inspectDetailLoading = true
      this.inspectDetail = null
      getDormInspectRecordDetail({ id }).then(res => {
        this.inspectDetail = this.normalizeInspectRecordDetail((res.data && res.data.response) || null)
        if (!this.inspectDetail) this.$message.warning((res.data && res.data.msg) || '记录不存在')
      }).catch(() => {
        this.$message.error('加载明细失败')
      }).finally(() => {
        this.inspectDetailLoading = false
      })
    },
    /** 明细接口 { Record, Items, Classes } 展平，供摘要区直接绑定。创建于 2026-09-20 */
    normalizeInspectRecordDetail(resp) {
      if (!resp) return null
      const record = resp.Record || resp.record || {}
      const items = resp.Items || resp.items || []
      const classes = resp.Classes || resp.classes || record.Classes || []
      return {
        ...record,
        Items: items,
        Classes: classes,
        ClassNames: record.ClassNames || (classes.length
          ? classes.map(c => c.DepartmentName || c.Name).filter(Boolean).join('、')
          : ''),
      }
    },
    formatInspectDate(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val.substring(0, 10)
      try {
        const d = new Date(val)
        if (Number.isNaN(d.getTime())) return String(val)
        const m = `${d.getMonth() + 1}`.padStart(2, '0')
        const day = `${d.getDate()}`.padStart(2, '0')
        return `${d.getFullYear()}-${m}-${day}`
      } catch (e) {
        return String(val)
      }
    },
    filterTreeNode(value, data) {
      if (!value) return true
      const val = String(value).trim().toLowerCase()
      if (data.Label && String(data.Label).toLowerCase().indexOf(val) >= 0) return true
      if (data.Type === 'building' && this.matchedBuildingIds.indexOf(String(data.BuildingId || data.Id)) >= 0) return true
      if (data.Type === 'floor' && this.matchedFloorIds.indexOf(String(data.FloorId || data.Id)) >= 0) return true
      return false
    },
    isRoomSearchMatched(room) {
      if (!this.isSearching || !this.globalSearchQuery || !room) return false
      const q = this.globalSearchQuery.trim().toLowerCase()
      const code = String(room.RoomCode || room.RoomName || '').toLowerCase()
      if (code.indexOf(q) >= 0) return true
      return (room.Beds || []).some(b => this.isBedSearchMatched(b))
    },
    isBedSearchMatched(bed) {
      if (!this.isSearching || !this.globalSearchQuery || !bed || !this.isBedOccupied(bed)) return false
      const q = this.globalSearchQuery.trim().toLowerCase()
      const name = String(bed.OccupantName || '').toLowerCase()
      const no = String(bed.OccupantNo || '').toLowerCase()
      const card = String(bed.OccupantCardNo || '').toLowerCase()
      if (this.globalSearchType === 'studentName') return name.indexOf(q) >= 0
      if (this.globalSearchType === 'studentNo') return no.indexOf(q) >= 0
      if (this.globalSearchType === 'studentCard') return card.indexOf(q) >= 0 || card.indexOf(q.padStart(10, '0')) >= 0
      if (this.globalSearchType === 'room') return false
      return name.indexOf(q) >= 0 || no.indexOf(q) >= 0 || card.indexOf(q) >= 0 || card.indexOf(q.padStart(10, '0')) >= 0
    },
    exitSearchMode() {
      this.isSearching = false
      this.matchedBuildingIds = []
      this.matchedFloorIds = []
      if (this.$refs.tree) this.$refs.tree.filter('')
    },
    clearGlobalSearch() {
      this.globalSearchQuery = ''
      this.handleGlobalSearch('')
    },
    onGlobalSearchInput() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = setTimeout(() => {
        this.handleGlobalSearch(this.globalSearchQuery)
      }, 300)
    },
    async handleGlobalSearch(val) {
      const query = val ? String(val).trim() : ''
      if (!query) {
        this.exitSearchMode()
        const target = this.lastSelectedNode
        if (target) {
          this.onNodeClick(target)
        } else if (this.currentBuildingId) {
          this.loadRooms(this.schoolDepartmentId)
        }
        return
      }

      const schoolId = String(this.schoolDepartmentId || '')
      if (!schoolId) {
        this.$message.warning('请先在顶栏选择学校')
        return
      }
      if (!this.isSearching && (this.currentBuildingId || this.currentFloorId)) {
        this.lastSelectedNode = {
          Type: this.currentFloorId ? 'floor' : 'building',
          BuildingId: this.currentBuildingId,
          FloorId: this.currentFloorId,
          Label: this.currentLabel,
          Id: this.currentFloorId || this.currentBuildingId
        }
      }
      this.isSearching = true
      this.currentLabel = ''
      this.$nextTick(() => {
        if (this.$refs.tree) this.$refs.tree.setCurrentKey(null)
      })
      const requestId = ++this.roomsRequestId
      this.rooms = []
      this.loading = true
      try {
        const res = await getRoomsWithBeds({
          departmentId: schoolId,
          query,
          searchType: this.globalSearchType
        })
        if (requestId !== this.roomsRequestId) return
        if (res.data && res.data.success) {
          const searchRooms = res.data.response || []
          this.rooms = searchRooms
          const buildingSet = []
          const floorSet = []
          searchRooms.forEach(room => {
            if (room.BuildingId && buildingSet.indexOf(String(room.BuildingId)) < 0) buildingSet.push(String(room.BuildingId))
            if (room.FloorsId && floorSet.indexOf(String(room.FloorsId)) < 0) floorSet.push(String(room.FloorsId))
          })
          this.matchedBuildingIds = buildingSet
          this.matchedFloorIds = floorSet
          if (buildingSet.length && this.treeData.length) {
            this.defaultExpandedKeys = this.treeData
              .filter(b => buildingSet.indexOf(String(b.BuildingId || b.Id)) >= 0)
              .map(b => b.Id)
          }
          this.$nextTick(() => {
            if (this.$refs.tree) this.$refs.tree.filter(query)
          })
        } else {
          this.$message.error((res.data && res.data.msg) || '搜索失败')
        }
      } finally {
        if (requestId === this.roomsRequestId) this.loading = false
      }
    },
    openSummaryDetail(type, title, extraParams = {}) {
      this.detailDialogTitle = title
      this.detailType = type
      this.detailBuildingId = extraParams.buildingId || null
      this.detailFloorId = extraParams.floorId || null
      this.detailRoomType = null
      this.detailQuery = ''
      this.detailPage = 1
      if (type === 'boyOccupied') {
        this.detailType = 'occupied'
        this.detailGender = 'boy'
      } else if (type === 'girlOccupied') {
        this.detailType = 'occupied'
        this.detailGender = 'girl'
      } else {
        this.detailType = type
        this.detailGender = 'all'
      }
      this.detailDataType = (this.detailType === 'totalBeds' || this.detailType === 'emptyBeds' || this.detailType === 'totallyEmptyRooms') ? 'bed' : 'student'
      this.detailDialogVisible = true
      this.fetchDetailData()
    },
    onDetailBuildingChange() {
      this.detailFloorId = null
      this.handleDetailFilterChange()
    },
    handleDetailFilterChange() {
      this.detailPage = 1
      this.fetchDetailData()
    },
    resetDetailFilters() {
      this.detailBuildingId = null
      this.detailFloorId = null
      this.detailRoomType = null
      this.detailQuery = ''
      this.detailGender = 'all'
      this.detailPage = 1
      this.fetchDetailData()
    },
    onDetailPageChange(page) {
      this.detailPage = page
      this.fetchDetailData()
    },
    onDetailPageSizeChange(size) {
      this.detailPageSize = size
      this.detailPage = 1
      this.fetchDetailData()
    },
    async fetchDetailData() {
      const schoolId = String(this.schoolDepartmentId || '')
      if (!schoolId) return
      this.detailLoading = true
      try {
        const params = {
          departmentId: schoolId,
          type: this.detailType,
          buildingId: this.detailBuildingId || undefined,
          floorId: this.detailFloorId || undefined,
          roomType: this.detailRoomType === null || this.detailRoomType === '' ? undefined : this.detailRoomType,
          query: this.detailQuery ? this.detailQuery.trim() : undefined,
          page: this.detailPage,
          intPageSize: this.detailPageSize
        }
        if (this.detailDataType === 'student') {
          if (this.detailGender === 'boy') params.gender = 0
          if (this.detailGender === 'girl') params.gender = 1
        }
        const res = await getOccupancyDetails(params)
        if (res.data && res.data.success) {
          const page = res.data.response || {}
          this.detailList = page.data || []
          this.detailTotal = page.dataCount || 0
        } else {
          this.detailList = []
          this.detailTotal = 0
          this.$message.error((res.data && res.data.msg) || '加载明细失败')
        }
      } catch (e) {
        this.detailList = []
        this.detailTotal = 0
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style scoped>
.dorm-board-page {
  --male: #2563eb;
  --male-soft: #dbeafe;
  --female: #db2777;
  --female-soft: #fce7f3;
  display: flex;
  flex-direction: column;
  /* 填满 content-az，禁止再用 100vh 顶破外框造成空白可滚 */
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  background: #f4f7fc;
}

.board-top {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px 0;
}
.board-tabs {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
}
.board-tabs >>> .el-tabs__header {
  margin: 0 0 8px;
}
.board-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background: #e2e8f0;
}
.board-tabs >>> .el-tabs__item {
  height: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #64748b;
}
.board-tabs >>> .el-tabs__content {
  display: none;
}

.board-search-bar {
  flex: 0 1 560px;
  max-width: 560px;
  height: 38px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  display: flex;
  align-items: center;
  padding: 2px 4px 2px 6px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color .2s ease, box-shadow .2s ease;
}
.board-search-bar:hover {
  border-color: #99f6e4;
}
.board-search-bar:focus-within {
  border-color: var(--dorm-primary);
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.15);
}
.search-dimension-select {
  width: 118px;
  flex-shrink: 0;
}
.search-dimension-select >>> .el-input__inner {
  border: none !important;
  background: transparent !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #334155 !important;
  padding-left: 4px !important;
  padding-right: 20px !important;
  height: 32px !important;
  line-height: 32px !important;
  box-shadow: none !important;
}
.search-divider {
  width: 1px;
  height: 18px;
  background: #e2e8f0;
  margin: 0 6px 0 2px;
  flex-shrink: 0;
}
.search-input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 0;
}
.search-input-icon {
  color: #94a3b8;
  font-size: 14px;
  margin-right: 6px;
  flex-shrink: 0;
}
.search-native-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #0f172a;
  height: 100%;
  min-width: 0;
  padding: 0;
  font-family: inherit;
}
.search-native-input::placeholder {
  color: #94a3b8;
}
.search-clear-icon {
  color: #cbd5e1;
  font-size: 15px;
  cursor: pointer;
  margin: 0 6px;
  flex-shrink: 0;
}
.search-clear-icon:hover {
  color: #64748b;
}
.search-submit-btn {
  height: 30px;
  padding: 0 12px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.28);
  flex-shrink: 0;
}
.search-submit-btn:hover {
  background: linear-gradient(135deg, #0d9488, #0f766e);
}

.board-layout {
  flex: 1;
  height: auto;
  min-height: 0;
  max-height: none;
  padding-top: 0;
}

.board-layout > .dp-left {
  width: 280px;
  flex: 0 0 280px;
  margin-right: 16px;
}

.left-panel,
.right-panel {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.right-panel {
  flex: 1 1 auto;
  min-width: 0;
  padding: 12px 14px;
}

.panel-head {
  padding: 14px 16px 12px;
  border-bottom: 1px solid var(--dorm-border-muted);
  background: #fff;
}
.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: var(--dorm-text-strong);
}
.panel-title i {
  color: var(--dorm-primary);
}
.panel-stat {
  margin-top: 8px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  color: var(--dorm-text);
}
.panel-stat em {
  font-style: normal;
  color: var(--dorm-muted);
  font-size: 12px;
}

.floor-tree {
  flex: 1;
  overflow: auto;
  padding: 8px 6px 12px;
  background: #fff;
}
.floor-tree >>> .el-tree-node__content {
  min-height: 40px;
  height: auto;
  border-radius: 8px;
  margin: 2px 4px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.floor-tree >>> .el-tree-node.is-current > .el-tree-node__content {
  background: var(--dorm-primary-soft) !important;
}
.floor-tree >>> .el-tree-node__content:hover {
  background: #f0fdfa;
}
.tree-node {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-right: 6px;
}
.node-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.node-label {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  line-height: 18px;
  font-size: 13px;
  color: #0f172a;
}
.tree-node.is-building .node-label {
  font-weight: 650;
}
.gender-pill {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}
.gender-pill.male {
  color: var(--male);
  background: var(--male-soft);
}
.gender-pill.female {
  color: var(--female);
  background: var(--female-soft);
}
.occ-badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
}

.room-toolbar {
  padding: 0 0 10px;
  border-bottom: 1px solid var(--dorm-border-muted);
  background: #fff;
}
.selection-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.selection-meta h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--dorm-text-strong);
}
.selection-meta h3 small {
  margin-left: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}
.chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.chip {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  border-radius: 999px;
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all .15s ease;
}
.chip:hover {
  border-color: var(--dorm-border);
  color: var(--dorm-primary-deep);
}
.chip.active {
  border-color: var(--dorm-primary);
  background: var(--dorm-primary-soft);
  color: var(--dorm-primary-deep);
  font-weight: 600;
}

.room-grid {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 14px 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));
  gap: 12px;
  align-content: start;
  background: #fff;
}

.room-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 118px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
}
.room-card:hover {
  transform: translateY(-2px);
  border-color: var(--dorm-border);
  box-shadow: 0 8px 20px rgba(13, 148, 136, 0.12);
}
.room-card.is-full {
  border-color: #fecaca;
  background: #fffafa;
}
.room-card.is-empty {
  border-color: #e2e8f0;
}
.room-card.is-manager {
  border-color: #fde68a;
  background: #fffbeb;
}
.room-card.is-nonlive {
  cursor: default;
  background: #f8fafc;
  opacity: 0.92;
}
.room-card.is-nonlive:hover {
  transform: none;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.room-card.is-search-matched {
  border-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}
.inspect-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 4px 0 2px;
  cursor: pointer;
}
.inspect-badge {
  display: inline-block;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 18px;
  font-weight: 600;
}
.inspect-badge.inspected {
  background: #ccfbf1;
  color: #0f766e;
}
.inspect-badge.deduct {
  background: #fee2e2;
  color: #b91c1c;
}
.room-card.has-deduct {
  border-color: #fecaca;
}
.inspect-summary-body p {
  display: flex;
  gap: 12px;
  margin: 0 0 10px;
  color: #334155;
  line-height: 1.5;
}
.inspect-summary-body span {
  width: 72px;
  flex-shrink: 0;
  color: #64748b;
}
.deduct-text {
  color: #dc2626;
}
.inspect-summary-row {
  padding: 14px 16px;
  margin-bottom: 12px;
}
.inspect-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 10px;
}
.inspect-kpi {
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.inspect-kpi em {
  display: block;
  font-style: normal;
  font-size: 12px;
  color: #64748b;
}
.inspect-kpi strong {
  display: block;
  margin-top: 4px;
  font-size: 20px;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}
.inspect-kpi.warn strong {
  color: #b91c1c;
}
.room-loc {
  margin-bottom: 6px;
  font-size: 11px;
  color: #0d9488;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.room-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.room-code {
  font-size: 16px;
  font-weight: 750;
  color: #0f172a;
  letter-spacing: 0.02em;
}
.room-type {
  flex-shrink: 0;
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 6px;
  background: #ecfeff;
  color: #0f766e;
}
.room-type.type-1 {
  background: #fff7ed;
  color: #c2410c;
}
.room-type.type-2 {
  background: #f1f5f9;
  color: #64748b;
}

.bed-dots {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 18px;
  margin-bottom: 12px;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e2e8f0;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
}
.dot.on {
  background: var(--dorm-primary);
}
.dot.on.is-in {
  background: #10b981;
}
.dot.on.is-out {
  background: #f59e0b;
}
.dot.on.is-leave {
  background: #6366f1;
}
.dot.on.is-unknown {
  background: #94a3b8;
}
.dot.is-matched {
  transform: scale(1.25);
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.45);
  background: #f59e0b !important;
}
.no-bed {
  font-size: 12px;
  color: #94a3b8;
}

.room-foot {
  margin-top: auto;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
}
.bar-wrap {
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}
.bar {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #14b8a6, #0d9488);
  transition: width .2s ease;
}
.room-card.is-full .bar {
  background: linear-gradient(90deg, #fb7185, #e11d48);
}
.cap {
  font-size: 12px;
  color: #64748b;
  font-variant-numeric: tabular-nums;
  min-width: 42px;
  text-align: right;
}
.non-live {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
}

.empty-state {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 72px 16px;
  color: #94a3b8;
}
.empty-state i {
  font-size: 36px;
  color: #cbd5e1;
}
.empty-state p {
  margin: 0;
}
.empty-state.compact {
  padding: 40px 16px;
}

/* 数据汇总 */
.summary-layout {
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 24px 24px;
  padding: 12px 14px;
}

.kpi-row {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}
.kpi-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}
.kpi-card.is-clickable,
.gender-card.is-clickable,
.is-clickable {
  cursor: pointer;
}
.kpi-card.is-clickable:hover,
.gender-card.is-clickable:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(13, 148, 136, 0.12);
}
.kpi-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.kpi-value {
  font-size: 24px;
  font-weight: 750;
  color: #0f172a;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}
.kpi-value small {
  margin-left: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}
.kpi-label {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}

.gender-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.gender-card {
  padding: 16px 18px;
}
.gender-card.male {
  border-color: #bfdbfe;
  background: linear-gradient(180deg, #eff6ff 0%, #fff 70%);
}
.gender-card.female {
  border-color: #fbcfe8;
  background: linear-gradient(180deg, #fdf2f8 0%, #fff 70%);
}
.gender-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 650;
}
.gender-head strong {
  font-size: 22px;
  font-variant-numeric: tabular-nums;
}
.gender-card.male .gender-head strong { color: var(--male); }
.gender-card.female .gender-head strong { color: var(--female); }
.gender-bar {
  height: 8px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
  margin-bottom: 12px;
}
.gender-bar i {
  display: block;
  height: 100%;
  border-radius: inherit;
}
.gender-card.male .gender-bar i { background: linear-gradient(90deg, #60a5fa, #2563eb); }
.gender-card.female .gender-bar i { background: linear-gradient(90deg, #f472b6, #db2777); }
.gender-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 18px;
  font-size: 12px;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}

.building-summary {
  padding: 16px;
}
.summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.summary-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}
.summary-head span {
  font-size: 12px;
  color: #64748b;
}
.building-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}
.building-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  background: #fff;
  transition: border-color .15s ease, box-shadow .15s ease;
}
.building-card:hover {
  border-color: var(--dorm-border);
  box-shadow: 0 6px 18px rgba(13, 148, 136, 0.1);
}
.bc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.bc-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.bc-title strong {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bc-floors {
  font-size: 12px;
  color: #94a3b8;
}
.bc-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 12px;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}
.bc-stats .rate {
  color: var(--dorm-primary-deep);
  font-weight: 650;
  text-align: right;
}
.bc-floors-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 220px;
  overflow: auto;
}
.floor-row {
  display: grid;
  grid-template-columns: 64px 72px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  font-size: 12px;
  border-radius: 6px;
  padding: 2px 4px;
}
.floor-row.is-clickable:hover {
  background: #f0fdfa;
}
.flabel {
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fnum {
  color: #64748b;
  font-variant-numeric: tabular-nums;
  text-align: right;
}
.fbar {
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}
.fbar i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #5eead4, #0d9488);
}
.floor-empty {
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
  padding: 8px 0;
}

.detail-filter {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px 0;
  margin-bottom: 12px;
}
.detail-filter >>> .el-form-item {
  margin-bottom: 8px;
  margin-right: 12px;
}
.detail-count {
  margin-bottom: 10px;
  font-size: 13px;
  color: #475569;
}
.detail-count strong {
  color: #0d9488;
  font-size: 15px;
}
.detail-room {
  font-weight: 700;
  color: #0f766e;
}
.detail-pager {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}
.bc-stats .is-clickable:hover {
  color: #0d9488;
}

@media (max-width: 1280px) {
  .kpi-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 960px) {
  .board-top {
    flex-direction: column;
    align-items: stretch;
  }
  .board-search-bar {
    max-width: none;
    flex: none;
  }
  .board-layout {
    flex-direction: column;
  }
  .left-panel {
    width: 100%;
    flex: 0 0 auto;
    max-height: 280px;
    margin-right: 0;
  }
  .kpi-row,
  .gender-row {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
/* 房间人员名册气泡（append 到 body） */
.dorm-room-roster-pop {
  padding: 0 !important;
  border: none !important;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18) !important;
  background: #0f172a !important;
}
.dorm-room-roster-pop .roster-pop {
  color: #e2e8f0;
  padding: 12px 14px 10px;
}
.dorm-room-roster-pop .roster-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
}
.dorm-room-roster-pop .roster-head strong {
  font-size: 13px;
  color: #fff;
}
.dorm-room-roster-pop .roster-head span {
  font-size: 12px;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}
.dorm-room-roster-pop .roster-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 260px;
  overflow: auto;
}
.dorm-room-roster-pop .roster-list li {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  font-size: 12px;
  line-height: 1.4;
}
.dorm-room-roster-pop .roster-list em {
  flex-shrink: 0;
  width: 42px;
  font-style: normal;
  color: #94a3b8;
}
.dorm-room-roster-pop .roster-list .mini-avatar {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  flex: 0 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 11px;
  font-weight: 700;
}
.dorm-room-roster-pop .roster-list .mini-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.dorm-room-roster-pop .roster-list .who {
  flex-shrink: 0;
  color: #f8fafc;
  font-weight: 600;
}
.dorm-room-roster-pop .roster-list .klass {
  min-width: 0;
  flex: 1;
  color: #94a3b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dorm-room-roster-pop .roster-list .no {
  color: #94a3b8;
}
.dorm-room-roster-pop .roster-list .empty {
  color: #64748b;
}
.dorm-room-roster-pop .roster-list .presence {
  margin-left: auto;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  padding: 0 5px;
  border-radius: 3px;
}
.dorm-room-roster-pop .roster-list .presence.is-in {
  color: #6ee7b7;
  background: rgba(16, 185, 129, 0.18);
}
.dorm-room-roster-pop .roster-list .presence.is-out {
  color: #fcd34d;
  background: rgba(245, 158, 11, 0.18);
}
.dorm-room-roster-pop .roster-list .presence.is-leave {
  color: #a5b4fc;
  background: rgba(99, 102, 241, 0.2);
}
.dorm-room-roster-pop .roster-list .presence.is-miss {
  color: #fca5a5;
  background: rgba(239, 68, 68, 0.18);
}
.dorm-room-roster-pop .roster-list .presence.is-unknown {
  color: #94a3b8;
  background: rgba(148, 163, 184, 0.15);
}
.dorm-room-roster-pop .roster-empty {
  font-size: 12px;
  color: #94a3b8;
  padding: 8px 0;
}
.dorm-room-roster-pop .roster-tip {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  font-size: 11px;
  color: #5eead4;
}
</style>
